import { render, staticRenderFns } from "./EditCorrespondance.vue?vue&type=template&id=1b5474b8&"
import script from "./EditCorrespondance.vue?vue&type=script&lang=ts&"
export * from "./EditCorrespondance.vue?vue&type=script&lang=ts&"
import style0 from "./EditCorrespondance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports